// service.js
import DataService from "../dataService";
import api from "../api";

const getPad = async () => {
    try {
        const response = await DataService.get(api.padApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching getPad';
    }
};
const getStudyReports = async () => {
    try {
        const response = await DataService.get(api.studyReportsApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching getStudyReports';
    }
};
const getMeetingMinutes = async () => {
    try {
        const response = await DataService.get(api.meetingMinutesApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching getMeetingMinutes';
    }
};
const getProjectDocuments = async () => {
    try {
        const response = await DataService.get(api.projectDocumentsApi);
        return response.data;
    } catch (error) {
        console.error('API Error:', error);
        throw error?.message || 'An error occurred while fetching getProjectDocuments';
    }
};

export {
    getPad,
    getStudyReports,
    getMeetingMinutes,
    getProjectDocuments
};